export const environment = {
  production: true,
  apiUrl: "https://api.eazix.io",
  /** MapTiler Cloud API key — inject at build time / CI; do not commit real keys. */
  mapTilerApiKey: 'vcb9jeTslt2RyaGbzwU8',
  /** MapTiler map (style) UUID */
  mapTilerMapId: '0197cd49-90c4-751b-9113-725f6ff68205',
};
